import React, { useState, useEffect, useRef } from 'react';
import ChatWindow from './components/ChatWindow';
import MessageInput from './components/MessageInput';
import ChatService from './services/ChatService';
import './App.css';

function getUrlParameter(name) {
  if (typeof window === 'undefined') return null;
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}

function App({ masterId, inputRows, placeholder, headerTitle, sendButtonText }) {
  const [status, setStatus] = useState('接続中...');
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const chatServiceRef = useRef(null);

  // Add a new message to the chat
  const addMessage = (type, content) => {
    setMessages(prevMessages => [...prevMessages, { type, content }]);
  };

  // Update the last assistant message with additional content
  const updateLastAssistantMessage = (content) => {
    setMessages(prevMessages => {
      const newMessages = [...prevMessages];
      const lastAssistantIndex = newMessages
        .map((msg, index) => msg.type === 'assistant' ? index : -1)
        .filter(index => index !== -1)
        .pop();

      if (lastAssistantIndex !== undefined) {
        newMessages[lastAssistantIndex] = {
          ...newMessages[lastAssistantIndex],
          content: newMessages[lastAssistantIndex].content + content
        };
      } else {
        newMessages.push({ type: 'assistant', content });
      }

      return newMessages;
    });
  };

  // Initialize chat service
  useEffect(() => {

    if (typeof masterId === 'undefined') {
      masterId = getUrlParameter('master_id');
    }

    if (!masterId) {
      setStatus('master_id is required', true);
      return;
    }

    // Create chat service with callbacks
    chatServiceRef.current = new ChatService({
      onStatusChange: (message, isError) => {
        setStatus(message);
        console.log(`Status: ${message}${isError ? ' (Error)' : ''}`);
      },
      onConnectionChange: (connected) => {
        setIsConnected(connected);
      },
      onSystemMessage: (message) => {
        addMessage('system', message);
      },
      onAssistantMessage: (message) => {
        addMessage('assistant', message);
      },
      onAssistantMessageUpdate: (content) => {
        updateLastAssistantMessage(content);
      },
      onTypingChange: (typing) => {
        setIsTyping(typing);
      }
    }, masterId);

    // Initialize chat connection
    const initChat = async () => {
      await chatServiceRef.current.init();
    };

    initChat();

    // Cleanup on unmount
    return () => {
      if (chatServiceRef.current) {
        chatServiceRef.current.disconnect();
      }
    };
  }, [masterId]);

  // Send message handler
  const handleSendMessage = (message) => {
    if (chatServiceRef.current) {
      addMessage('user', message);
      chatServiceRef.current.sendMessage(message);
    }
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        <h1>{headerTitle || 'CMS QA Chat'}</h1>
      </div>

      <ChatWindow
        messages={messages}
        isTyping={isTyping}
      />

      <MessageInput
        isConnected={isConnected}
        onSendMessage={handleSendMessage}
        rows={inputRows}
        placeholder={placeholder}
        sendButtonText={sendButtonText}
      />

      <div className="chat-status">
        {status}
      </div>
    </div>
  );
}

export default App;
